import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getDeployments() {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/deployments", {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching deployments"
                });
            }
        });
    },
    getDeploymentDetails(id) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/deployments/"+id, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching details"
                });
            }
        });
    }
}
